import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { SingleDatePicker } from "react-dates";
import "./styles.css";
import Button from "../common/button";
import TextField from "../common/textField";
import RadioButton from "../common/radioButton";
import AutoComplete from "../common/autoComplete";
import SeatMap from "../seatMap";
import { DEAL_TYES_ALL_ROUTES } from "../../utils/constants";
import largeCross from "../../images/largeCross.svg";
import StyledInput from "../styleInput";
import dateCalendar from '../../../src/images/dateCalendar.svg';
import RouteButton from '../RouteButton/index';
import HalfPagePopup from "../HalfPagePopup";
import circleCross from '../../../src/images/circleCross.svg';
import * as actions from "../../containers/deals/actions";
import { disableBodyScrolling } from "../../utils";
import DealRadioButton from "../common/DealRadioButton";
import { CONDITIONS } from "./constants";
// import { process_params } from "express/lib/router";

const days = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];
const actionButtonStyle = {
  width: "90%",
  height: 50,
  padding: 0,
  margin: "10px 5px 30px 0px",
};
const searchButtonStyle = {
  width: "60%",
  height: 32,
  padding: 0,
  margin: "10px 0px 0px 20px",
};
const selectButtonStyle = {
  width: "100%",
  height: 32,
  padding: 0,
  // margin: "10px 5px 30px 20px",
};

function hightLightText(str, val) {
  var index = str.toLowerCase().indexOf(val.toLowerCase());
  if (index > 0) {
    return [
      str.substring(0, index),
      <b key={1} style={{ color: "#000" }}>
        {val}
      </b>,
      str.substring(index + val.length),
    ];
  } else if (index === 0) {
    return [
      <b key={1} style={{ color: "#000" }}>
        {str.substring(0, index + val.length)}
      </b>,
      str.substring(index + val.length),
    ];
  }
  return str;
}

const renderElements = function (item, value) {
  return (
    <div className="cursor">
      <p className="cityStyle">
        {value
          ? hightLightText(item.city_name || item.display_name, value)
          : item.city_name}
        {item.is_multi_district && item.district ? ` (${item.district})` : ""}
      </p>
      <p className="stateStyle">{item.state || ""}</p>
    </div>
  );
};

const dealTypeCheck = ({ dealType }) => {
  return DEAL_TYES_ALL_ROUTES.includes(dealType);
};

const DealsInputFields = (props) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  //Same bus For Different Route
  const [prevSource, setPrevSource] = useState([]);
  const [prevDestination, setPrevDestination] = useState([]);
  const [showSelectedReturnTripDeals, setshowSelectedReturnTripDeals] = useState(false);
  const [returnTripDeal, setReturnTripDeal] = useState([]);
  const { setReturnTripServicesList, onAllRoutesSelectionChange } = props;


  useEffect(() => {
    if(props.addClicked) {
      setPrevSource((prevData) => [...prevData, props.source]);
      setPrevDestination((prevData) => [...prevData, props.destination]);
    }
  }, [props.source, props.destination, props.addClicked]);

  useEffect(() => {//need to change not working
    disableBodyScrolling(true);

    return () =>  disableBodyScrolling(false);  
  }, [isPopupOpen]);

  useEffect(() => {
    setReturnTripServicesList(returnTripDeal);
    if(!returnTripDeal.length || returnTripDeal.every(returnTrip => !returnTrip.isSelected))
      onAllRoutesSelectionChange('', true);
    else onAllRoutesSelectionChange('', false);
  }, [returnTripDeal]);

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  const onSelectionRouteSelected = () => {
    props.onAllRoutesSelectionChange();
    togglePopup();
  }

  const sData = localStorage.getItem('service_List');
  const dataServiceList = props.servicesDataList || sData ? JSON.parse(sData) : [];
  let via_route_support =
    JSON.parse(localStorage.getItem("via-routes-support")) ||
    props.allRoutesInfo.via_route_support;

    const removeDataFromServiceList = (serviceList) => {
      let filterServiceDataList = [];
      filterServiceDataList = dataServiceList.filter((element) => element !== serviceList);
      props.getServiceList(filterServiceDataList);
      localStorage.setItem('service_List', JSON.stringify(filterServiceDataList || []));
    }
    const addRtripBtnClicked = () => {
      setshowSelectedReturnTripDeals(true);
    }

    const toggleSelectedReturnTripDeal = (index) => {
      const updatedReturnTripDeal = returnTripDeal.map((item, idx) => {
        if (idx === index) {
          return {
            ...item,
            isSelected: !item.isSelected, // Toggle isSelected for the specified index
          };
        }
        return item;
      });
      setReturnTripDeal(updatedReturnTripDeal);
    }

    const addReturnTripDeal = (services, index = -1) => {

    const dealExists = returnTripDeal.findIndex(deal => 
      deal.paytm_src_id === props.source.city_id && 
      deal.paytm_dest_id === props.destination.city_id
    );
    const returnDealExists = returnTripDeal.findIndex(deal => 
      deal.paytm_src_id === props.destination.city_id && 
      deal.paytm_dest_id === props.source.city_id
    );
    
    if (returnTripDeal[returnDealExists]) {
      returnTripDeal[returnDealExists].isReverseRoute = false;
    }
    if(dealExists === -1 && props.source && props.destination) {
      setReturnTripDeal([{
        source: props.source,
        destination: props.destination,
        paytm_src_id: props.source.city_id,
        paytm_dest_id: props.destination.city_id,
        isReverseRoute: returnTripDeal[returnDealExists] ? false : true,
        isSelected: true,
        servicesList: services
      }, ...returnTripDeal]);
    }
    else if(dealExists >= 0 && index !== -1) {
      addReverseRoute(index, services);
    }
    }

    const addReverseRoute = (index, services) => {
      let src, dest;

      if (returnTripDeal.length) {
        const updatedReturnTripDeal = returnTripDeal.map((item, idx) => {
          if (idx === index) {
            src = item.destination;
            dest = item.source;
            return {
              ...item,
              isReverseRoute: false, // Update isReverseRoute to false for the specified index
            };
          }
          return item;
        });
     
        setReturnTripDeal([
          {
            source: src,
            destination: dest,
            paytm_src_id: src.city_id,
            paytm_dest_id: dest.city_id,
            isReverseRoute: false,
            isSelected: true,
            servicesList: services
          },
          ...updatedReturnTripDeal,
        ]);
      }
    }

    const removeRTripRoute = (index) => {
      if(returnTripDeal.length === 1 && index === 0) {
        setReturnTripDeal([]);
      }
      else {
        const dealExists = returnTripDeal.findIndex(deal => 
          (deal.paytm_src_id ===  returnTripDeal[index].destination.city_id && 
          deal.paytm_dest_id ===  returnTripDeal[index].source.city_id)
        );

        if (returnTripDeal[dealExists] ) {
          returnTripDeal[dealExists].isReverseRoute = true;
        }
        const updatedReturnTripDeal = returnTripDeal.filter((_, i) => i !== index);
        setReturnTripDeal(updatedReturnTripDeal);
      }
    }

    const onSelectAllRoundTripDeals = () => {
      setReturnTripDeal(
        returnTripDeal.map((deal) => ({
          ...deal,
          isSelected: true,
        }))
      );
      onAllRoutesSelectionChange('', true);
    };
  return (
    <div className="col-xs-12 payout-content">
      <div className={isPopupOpen ? "disableBackground" : ''}>
      <p className="colorb3b3b3 deal-content">Fill additional details to create Deal</p>
      <div className="row">
        <div className="deal-discount-type-wrp marginTop20">
        </div>
        <div className="col-xs-6" />
        <div className='fullWidth'>
        <div className="discountTypeText">Discount Type</div>
    <input
      type="radio"
      id="flatDiscount"
      name="discountType"
      value="FLAT"
      checked={props.discountType === "FLAT"}
      onChange={props.onDiscountTypeChange}
    />
    <label className="discountLbl" htmlFor="flatDiscount">Flat</label>
    <input
      type="radio"
      id="percentDiscount"
      name="discountType"
      value="PERCENT"
      checked={props.discountType === "FLAT" ? false : true}
      onChange={props.onDiscountTypeChange}
    />
    <label className="discountLbl" htmlFor="percentDiscount">Percentage</label>
</div>
        <div className="col-xs-6 deal-textfield marginTop20">
          <div className="dealData">
          {props.discountType !== "FLAT" ? 'Enter deal value in %' : 'Enter deal value in number'}
          </div>
          <StyledInput
          startAdornment={'₹'}
          endAdornment={'%'}
           type= {
            props.discountType !== "FLAT" ? "text" : "number"
          }
           name="discountValue"
           discountType={props.discountType}
           value={props.discountValue}
           onChange={props.onInputFieldChange}
           placeholder={"e.g. 10, 15, 20 "}
           errorMsg={""}
           flag={true}
           />
        </div>
      </div>
      { props.dealType !== 'RETURN_TRIP' &&  props.dealType !== 'FEMALE_DEAL' &&
      <>
      <div className="seatFare">Seat fare</div>
      <div className="seatFareLbl">Set the minimum & maximum seat fare eligible for this deal</div>
      <div className="row deal-date-range-wrp marginTop20">
        <StyledInput
          type="number"
          customClass="col-xs-6 deal-padding-right"
          name="minSeatFare"
          value={props.minSeatFare}
          onChange={props.onInputFieldChange}
          placeholder="Minimum seat fare"
          errorMsg={""}
        />
        <StyledInput
          type="number"
          customClass="col-xs-6"
          name="maxSeatFare"
          value={props.maxSeatFare}
          onChange={props.onInputFieldChange}
          placeholder="Maximum seat fare"
          errorMsg={""}
        />
      </div>
      </>
    }
      <div className="deal-date-range-wrp marginTop20">
        <div>
        <div className="seatFare">Maximum discount value</div>
       <div className="seatFareLbl">Set the maximum amount that can be claimed by using this deal</div>
          <StyledInput
            type="number"
            name="maxDiscountValue"
            disabled={props.discountType === "FLAT"}
            value={props.discountType === "FLAT" ? '' : props.maxDiscountValue}
            onChange={props.onInputFieldChange}
            placeholder={'Enter here'
          }
            errorMsg={""}
          />
        </div>
        {(props.dealType === "EARLY_BIRD") ? (
          <div>
            <div className="seatFare">Number of seats</div>
            <div className="seatFareLbl">Set the number of seats on which the deal will be applicable</div>
            <StyledInput
              type="number"
              name="earlyBirdNumOfSeats"
              value={props.earlyBirdNumOfSeats}
              onChange={props.onInputFieldChange}
              placeholder="Enter here"
              errorMsg={""}
            />
          </div>
        ) : null}
      </div>
      {/* deal start time field */}
      {props.dealType === "LAST_MINUTE" ? (
        <div className="marginTop20 deal-padding-right">
          <div className="col-xs-6">
            <select
              className={`deal-discount-type${
                props.dealStartTimeInHours != "-1" ? " blackFont" : ""
              }`}
              value={props.dealStartTimeInHours}
              onChange={props.onDealStartTimeInHoursChange}
            >
              <option disabled value="-1">
                Deal Start Time *
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
            </select>
          </div>
        </div>
      ) : null}

      {/* seat occupancy threshold */}
      {props.dealType === "LAST_MINUTE" && (
        <React.Fragment>
          <div className="row deal-date-range-wrp marginTop20">
            <TextField
              type="number"
              customClass="col-xs-6 deal-padding-right"
              name="startDealOccupancyThreshold"
              value={props.startDealOccupancyThreshold}
              onChange={props.onInputFieldChange}
              placeholder="Start deal when occupancy is less than Y% *"
              errorMsg={""}
              lastMinute
            />         
           <TextField
              type="number"
              customClass="col-xs-6"
              name="stopDealOccupancyThreshold"
              value={props.stopDealOccupancyThreshold}
              onChange={props.onInputFieldChange}
              placeholder="Stop deal when occupancy reaches Z% *"
              errorMsg={""}
              lastMinute
            />
          </div>
        </React.Fragment>
      )}

    <div className="seatFare">Add date</div>
      <div className="seatFareLbl">Set the dates when the deal will be valid</div>
      <div className="row deal-date-range-wrp marginTop20">
        <div className={`col-xs-4 date-calendar ${props.isEditCase ? 'disabled-date-picker' : ''}`} onClick={() => !props.isEditCase && props.onStartFocusChange({focused: true})}>
          <SingleDatePicker
            id="start_date"
            disabled={props.isEditCase}
            daySize={30}
            date={props.startDate}
            placeholder="Start Date "
            displayFormat="DD-MM-YYYY"
            focused={props.focusedStartDate}
            hideKeyboardShortcutsPanel={true}
            onDateChange={props.onStartDateChange}
            onFocusChange={props.onStartFocusChange}
          />
          <img className="dateCalendar" src={dateCalendar} alt=''/>
        </div>
        <div className="col-xs-4 deal-end-date date-calendar" onClick={() => props.onEndFocusChange({focused: true})}>
          <SingleDatePicker
            id="end_date"
            daySize={30}
            date={props.endDate}
            placeholder="End Date"
            displayFormat="DD-MM-YYYY"
            focused={props.focusedEndDate}
            hideKeyboardShortcutsPanel={true}
            onDateChange={props.onEndDateChange}
            onFocusChange={props.onEndFocusChange}
          />
          <img className="dateCalendar" src={dateCalendar} alt='' />
        </div>
      </div>

    { props.dealType !== 'RETURN_TRIP' && props.dealType !== 'FEMALE_DEAL' &&
    <>
      <div className="seatFare">Excluded dates</div>
      <div className="seatFareLbl">Set the dates when the deal will not be valid</div>
      <div className="row deal-date-range-wrp marginTop20">
        <div className="col-xs-4 date-calendar">
          <SingleDatePicker
            id="excluded_dates"
            daySize={30}
            date={props.excludedDates}
            focused={props.focusedExcluedDate}
            hideKeyboardShortcutsPanel={true}
            onDateChange={props.onExcludedDateChange}
            onFocusChange={props.onExcludedFocusChange}
            isOutsideRange={props.excludeDateRangeChecker}
            placeholder="Excluded Dates"
          />
          <img onClick={() => props.onExcludedFocusChange({focused: true})} className="dateCalendar" src={dateCalendar} />
        </div>
        <div className="col-xs-12" style={{ marginTop: 20 }}>
          {props.excludedDatesArr.map((el, index) => (
            <p className="deal-exclude-date" key={el}>
              {el}
              <span
                className="deal-exclude-date-close"
                onClick={() => props.onRemoveExculdedDate(el)}
              >
                x
              </span>
            </p>
          ))}
        </div>
      </div>
    </>
    }
   { props.dealType !== 'RETURN_TRIP' && props.dealType !== 'FEMALE_DEAL' &&
    <>
      <div className="seatFare seatDate">Set the days when the deal will be valid</div>
      <div className="row deal-date-range-wrp marginTop10">
        <div className="deals-day-wrp radio-container">
          {days.map((el) => (
            <DealRadioButton
              key={el}
              label={el}
              isChecked={props.applicableDays.includes(el)}
              onSelectionChange={props.onApplicableDaysChange}
            />
          ))}
        </div>
      </div>
    </>
    }
      {dealTypeCheck(props) && (
        <React.Fragment>
          <div className="seatFare">Set the routes on which the deal will be valid</div>
          <div className="selectedRoute marginTop20">
           {!(props.dealType === 'SEAT_LEVEL') && <RouteButton
              label="All routes"
              disabled={props.isEditCase}
              isChecked={props.isAllRoutesSelected}
              onSelectionChange={props.onAllRoutesSelectionChange}
            />}
            <RouteButton
              label="Specific route"
              disabled={props.isEditCase ? props.isEditCase :  (props.isEditCase && props.isAllRoutesSelected)}
              isChecked={props.isAllRoutesSelected ? false : true}
              onSelectionChange={onSelectionRouteSelected}
            />
          </div>
        </React.Fragment>
      )}

      {
      showSelectedReturnTripDeals &&
        returnTripDeal.length > 0 && !props.isAllRoutesSelected &&
        returnTripDeal.find(returnTrip => returnTrip.isSelected) &&
        props.dealType === "RETURN_TRIP" && (
          <table className="returnTripDealTable">
            <thead>
              <tr>
                <th>Onward Route (Offer Valid)</th>
                <th className="returnRouteTitle">Return Route <span>(Offer Applied)</span></th>
              </tr>
            </thead>
    
                <tbody>
      
                {returnTripDeal.map(
                    (el, index) =>
                      el.isSelected && (
                        <tr key={el.id}>
                          <td className="routeName">
                            {el.source.city_name} - {el.destination.city_name}
                          </td>
                          <td className="returnRouteField">
                            <span className="routeName">{el.destination.city_name} - {el.source.city_name}</span>
                            <img
                              src={circleCross}
                              className="circleCrossImg"
                              alt="circleCross"
                              onClick={() => removeRTripRoute(index)}
                            />
                          </td>
                        </tr>
                      ),
                  )}
                </tbody>
          </table>
        )
    }
      
{!props.isAllRoutesSelected && dataServiceList && dataServiceList.map((element, index) => {
  return(
    <div className="serviceDataList" key={index}>
      <div className="serviceDataBody">
        {element.source}-{element.destination} - <span className="elipseSpan">{element.departure_datetime}, {element.bus_type_name}</span>
      </div>
      <img src={circleCross} onClick={() => removeDataFromServiceList(element)} alt="circleCross" />
    </div>);
})}

      {!props.isAllRoutesSelected && dataServiceList && dataServiceList.length > 0 && <div className="addMoreRoutes" onClick={() => togglePopup()}>Add more routes</div>}
      {props.showViaRoutesWindow && (
        <div className="viaRoutesWindow">
          <div className="viaRoutesContainer">
            <div className="windowHead">
              <span>{`Deal will be created for these intermediate routes for the ${props.selectedServiceTime} ${props.selectedServiceRouteName} ${props.selectedServiceBusType} service -`}</span>{" "}
              <img
                className="crossLogo"
                onClick={() => props.setShowViaRoutesWindow(false)}
                src={largeCross}
                alt="cross"
              />
            </div>
            <div className="windowContent">
              {props.currentViaRoutes.map((route) => (
                <li>{route}</li>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="row dealButton">
      <div className="col-xs-3">
          <Button
            styleObj={actionButtonStyle}
            label="Cancel"
            onButtonClick={props.onCancelClick}
          />
        </div>
        <div className="col-xs-3">
          <Button
            styleObj={actionButtonStyle}
            label={props.isEditCase ? "Update" : "Create Deal"}
            onButtonClick={(data) => {
              props.onCreateDealClick(data);
            }}
          />
        </div>
      </div>

      {props.dealType === "RETURN_TRIP" &&
        <div className="conditions">
          <h1>CONDITIONS</h1>
          <ul>
          {CONDITIONS.map((c, i) => (
            <li key={i}>{c}</li>
          ))}
          </ul>
        </div>
      }
      </div>

      {isPopupOpen && (props.dealType === "RETURN_TRIP" || !props.isAllRoutesSelected)  && <HalfPagePopup 
      isOpen={isPopupOpen} 
      onClose={togglePopup}
      dealTypeCheck={dealTypeCheck}
      props={props}
      renderElements={renderElements}
      via_route_support={via_route_support}
      searchButtonStyle={searchButtonStyle}
      dataServiceList={dataServiceList}
      dealType={props.dealType}
      returnTripDeal={returnTripDeal}
      addReturnTripDeal={addReturnTripDeal}
      addRtripBtnClicked={addRtripBtnClicked}
      addReverseRoute={addReverseRoute}
      toggleSelectedReturnTripDeal={toggleSelectedReturnTripDeal}
      onSelectAllRoundTripDeals={onSelectAllRoundTripDeals}
       />}
    </div>
  );
};

const mapStateToProps = store => ({
  servicesDataList: store.dealsReducer.servicesDataList,
  addClicked: store.dealsReducer.addClicked,
  dynamicSeatData: store.dealsReducer,
})

const mapDispatchToProps = (dispatch) => ({
  getServiceList: (servicesDataList) => dispatch(actions.getServiceList(servicesDataList)),
  getSeat: (data) => dispatch(actions.getSeat(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DealsInputFields);


	